var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"color":_vm.color,"block":_vm.block,"loading":_vm.loading,"width":_vm.width != '' ? _vm.width : '',"disabled":_vm.disabled,"dark":!_vm.disabled,"elevation":"1"},on:{"click":function($event){return _vm.onClick()}}},[_vm._v(_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }